/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsLogoutMutationVariables = {};
export type mutationsLogoutMutationResponse = {
    readonly logout: boolean;
};
export type mutationsLogoutMutation = {
    readonly response: mutationsLogoutMutationResponse;
    readonly variables: mutationsLogoutMutationVariables;
};



/*
mutation mutationsLogoutMutation {
  logout
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "logout",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsLogoutMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "mutationsLogoutMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "69922a44dca7bfb6918fef6a58fa11c1",
    "id": null,
    "metadata": {},
    "name": "mutationsLogoutMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsLogoutMutation {\n  logout\n}\n"
  }
};
})();
(node as any).hash = 'f28b103be07114ba91a37aa96e5d1dcd';
export default node;
